/**
 * Step 6 — Success.
 *
 * Per `rcp-apply-now-step6-success.html`.
 *
 * A11y:
 *   - Focus lands on h1 on mount so screen readers read the success message first.
 *   - Success icon has `aria-hidden="true"`; visible text carries the meaning.
 */

import { useEffect, useRef } from 'react';
import { Link } from 'react-router';
import { CheckCircle2, Home, Mail } from '@retail-ops/panel-shell/fi';
import { useApplyWizard } from './ApplyWizard';

export function Step6Success(): JSX.Element {
  const { cartId, fundingAmount } = useApplyWizard();
  const headingRef = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <section aria-labelledby="step6-heading">
      <div className="card" style={{ textAlign: 'center', padding: 48 }}>
        <CheckCircle2 aria-hidden="true" size={64} color="var(--pcb-green)" />
        <h1 ref={headingRef} id="step6-heading" tabIndex={-1} style={{ marginTop: 16 }}>
          You&apos;re all set!
        </h1>
        <p style={{ fontSize: 16, color: 'var(--ink-700)', maxWidth: 480, margin: '16px auto' }}>
          Your application has been submitted. We&apos;ll email you when your account is ready —
          usually within one business day.
        </p>
        {fundingAmount ? (
          <p>
            <strong>Opening deposit:</strong> ${fundingAmount.toFixed(2)}
          </p>
        ) : null}
        {cartId ? (
          <p style={{ fontSize: 13, color: 'var(--ink-500)' }}>
            Your reference number: <span className="mono">{cartId}</span>
          </p>
        ) : null}
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 24, flexWrap: 'wrap' }}>
          <Link to="/dashboard" className="btn btn-primary">
            <Home aria-hidden="true" size={16} />
            Go to my portal
          </Link>
          <Link to="/inbox" className="btn btn-secondary">
            <Mail aria-hidden="true" size={16} />
            Check my inbox
          </Link>
        </div>
      </div>
    </section>
  );
}
